<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <f7-list class="mb-2">
                    <!--<f7-list-item :class="additionalClass">
                      <b-row class="d-flex">
                        <div class="mx-3">
                          <b-button class="btn btnFilter"
                            @click="onRefresh()">
                            <i class="fa-light fa-rotate-right"></i>
                          </b-button>
                        </div>
                      </b-row>
                    </f7-list-item>-->
                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true}">
                      <b-row class="min-w-100">
                        <!-- <b-col class="d-flex flex-row"> -->
                        <!--Filtre provider -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('common.global.provider_title') }}</span>
                          <span class="filter-item-content">
                            <input v-model="name"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': name}">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre identifiant -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('common.global.bic') }}</span>
                          <span class="filter-item-content">
                            <input v-model="identifier"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': identifier}">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre network -->
                        <b-col lg="3" cols="6" class="filter-item">
                          <span class="filter-item-title">{{ $t('common.global.clearing') }}</span>
                          <span class="filter-item-content">
                            <input v-model="network"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': network}">
                            </input>
                          </span>
                        </b-col>
                        <!-- Bouton Effacer et Appliquer -->
                        <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
                          <b-button class="btn" size="sm"
                            @click="applyFilters()">
                            {{ $t('filter.fltr') }}
                          </b-button>
                          <b-button class="btn mr-3" size="sm"
                            @click="emptyFilters"
                            :disabled="!hasInputFilter">
                            {{ $t('filter.clr_fltr_field') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </f7-list-item>
                  </f7-list>
        <spinner v-if="activateSpinner"></spinner>
        <b-table v-else-if="this.listItems.length > 0" responsive
          :items="listItems"
          :fields="fields"
          :key="keyTableProvider"
          :sort-by.sync="sortBy"
          hover :selectable="listItems.length > 0"
          empty-text="Pas de résultat"
          @row-selected="onRowSelected">
          <template #cell(name)="data">
              <span>{{ data.value }}</span>
          </template>
          <template #cell(identifier)="data">
              <span>{{ data.value }}</span>
          </template>
          <template #cell(norm)="data">
              <span>{{ data.value }}</span>
          </template>
          <!--
          <template #cell(edit)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.idMember)">
              <i class="fa-regular fa-pencil"></i>
              </span>
          </template>
          <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.idMember)">
              <i class="fa-regular fa-trash"></i>
              </span>
          </template>
          -->
        </b-table>
        <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
        <!--ANCIENNE TABLE DRO 05/07/2023
        <table v-else relative class="table b-table table-hover" :class="listItems.length ? 'b-table-selectable b-table-select-single' : ''">
          <thead role="rowgroup">
              <tr role="row">
              <th role="columnheader" class="text-center table-condensed-ipad">{{$t('common.global.table_title') }}</th>
              <th role="columnheader" v-if="canEdit" class="text-center table-condensed-ipad col-1">{{ $t('rights.edit') }}</th>
              <th role="columnheader" v-if="canDelete" class="text-center table-condensed-ipad col-1">{{ $t('rights.delete') }}</th>
              </tr>
          </thead>
          <tbody role="rowgroup">
              <tr role="row" v-if="activateSpinner">
              <td role="cell" colspan="3" class="text-center py-0">
                  <spinner class=""></spinner>
              </td>
              </tr>
              <tr role="row" v-else-if="listItems.length" v-for="(item, index) in listItems" :key="'item-' + index" @click="actionDetails($event, listItems.id)">
              <td role="cell" class="text-center">{{item.name}}</td>
              <td role="cell" v-if="canEdit"  class="text-center" @click="actionEdit($event, listItems.id)"><i class="fa-regular fa-pencil"></i></td>
              <td role="cell" v-if="canDelete"  class="text-center" @click="actionDelete($event, listItems.id)"><i class="fa-regular fa-trash"></i></td>
              </tr>
              <tr role="row" v-else class="no-hover">
              <td role="cell" colspan="3" class="text-center font-weight-bold">
                  Pas de résultat
              </td>
              </tr>
          </tbody>
        </table>-->
        <b-row class="justify-content-end mt-4 no-gutter">
          <b-button v-if="canAdd" variant="primary" @click="actionAdd" class="mx-2">
            <span class="d-inline">{{ $t('common.global.add_provider') }}</span>
          </b-button>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
name: 'ProviderList',
components: {
  'form-write-group-label-input':formWriteGroupLabelInput,
  'page-outline': PageOutline,
  'spinner': Spinner
},
props: {
},
computed: {
  canAdd () {
      return this.$engine.rights.rightIs('rtp_member_ajouter', true) 
  },
  canEdit () {
      return this.$engine.rights.rightIs('rtp_member_editer', true) 
  },
  canDelete () {
      return this.$engine.rights.rightIs('rtp_member_supprimer', true) 
  },
  fields () {
    return [
      { key: 'name', label: this.$t('common.global.provider_title'), thClass: 'text-center', tdClass: 'text-center w-75', sortable: true },
      { key: 'identifier', label: this.$t('common.global.bic'), thClass: 'text-center', tdClass: 'text-center', sortable: true },
      { key: 'norm', label: this.$t('common.global.clearing'), thClass: 'text-center', tdClass: 'text-center', sortable: true }
    ]

  },
  hasInputFilter () {
    if (
      this.name ||
      this.identifier ||
      this.network) {
      return true
    }
    return false
  },
  listTitle () {
    return this.$i18n.t('common.global.title')
  }
},
data: () => {
  return {
    activateSpinner: false,
    elementSearchedProvider: '',
    identifier: '',
    keyTableProvider: false,
    listItems: [],
    listNetworks: ['HRTP', 'SRTP'],
    name: '', 
    network: '', 
    sortBy: 'name'
  }
},
created () {
  this.activateSpinner = true
  this.getProviders()
},
methods: {
  actionAdd () {
    loadPage(this, { url: '/routing/provider/provider_form/add/-1'})
  },
  actionDelete ($e, id) {
    $e.stopPropagation()
    /*let that = this
    this.$f7.modal({
      title: this.$t('common.security.element_deletion_confirm'),
      buttons: [
        {
          text: this.$t('creation_forms.vldt'),
          onClick: function () {
            let params = {
              IdMember: IdMember
            }
            that.$engine.member.delete(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.security.ca_deleted'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/security/0'})
            })
            .catch(e => {
              errorMessageAlert(e, that, that.$i18n)
              that.okMessageBox(that.$t('common.security.cert_delete_error'))
            })
          }
        },
        {
          text: this.$t('common.cncl'),
          onClick: function () {
            return
          }
        }
      ]
    })*/
  },
  actionDetails (id) {
    loadPage(this, { url: '/routing/provider/provider_form/view/' + id })
  },
  actionEdit ($e, id) {
    $e.stopPropagation()
    loadPage(this, { url: '/routing/provider/provider_form/edit/' + id })
  },
  applyFilters() {
    this.activateSpinner = true
    let filterConditions = {
      name: this.name,
      identifier: this.identifier,
      network: this.network
    }
    this.getProviders(filterConditions)
  },
  emptyFilters() {
    this.name = ''
    this.identifier = ''
    this.network = ''
  },
  getProviders (filters) {
    this.$engine.routing.member.fetch(filters)
    .then(resp => {
      let that = this
      let providersList = {}
      providersList = resp.data.Members
      that.updateProviders(providersList)
    })
  },
  /*onRefresh() {
    this.activateSpinner = true
    this.getProviders(filterConditions)
  },*/
  onRowSelected(items) {
    this.keyTableProvider = !this.keyTableProvider
    this.actionDetails(items[0].idMember)
  },
  updateProviders(providersList) {
  this.listItems = providersList
  //this.fillNetworksList()
  this.activateSpinner = false
  }

}
}
</script>
